module.exports = __webpack_public_path__ + "img/empty.dd2c6162.png";